document.addEventListener('theme:variant:change', function(event) { 
  // The event.detail might contain the updated variant object and/or the product container
  //const productContainer = event.target || document.querySelector('[data-product-container]'); // Adjust selector based on your theme
  const productContainer = document.querySelector('[data-display_discount]'); // Adjust selector based on your theme
  const newVariant = event.detail.variant; // Or get it from the data attributes



  // Find your price display elements within the product container
  const priceElement = productContainer.querySelector('.price-item--sale'); // Example selector
  const compareAtPriceElement = productContainer.querySelector('.price-item--regular'); // Example selector

  if (newVariant && priceElement && compareAtPriceElement) { 
    // Clear previous custom elements if any (e.g., "On Sale!" label)
    productContainer.querySelectorAll('.price__sale-label, .price__percentage-saved').forEach(el => el.remove());

    // Check if it's a sale
    if (newVariant.compare_at_price > newVariant.price) { 

const sponsorCollectionSpan = document.querySelector('span[data-sponsor_collection]');
if (sponsorCollectionSpan) {
   const collectionTitle = sponsorCollectionSpan.textContent;
  if (collectionTitle.length>0){
 var discount_label= collectionTitle+' Discount:';    
  }else{
 var discount_label='Your Discount:';  
  }
}else{
  var discount_label='Your Discount:';
}


      
      // Re-insert your custom elements
      const saleLabel = document.createElement('span');
      saleLabel.className = 'price__sale-label';
      saleLabel.textContent = discount_label;
      priceElement.insertAdjacentElement('beforebegin', saleLabel); // Insert before the actual price

      const percentageSaved = Math.round(((newVariant.compare_at_price - newVariant.price) / newVariant.compare_at_price) * 100);
      const percentageSpan = document.createElement('span');
      percentageSpan.className = 'price__percentage-saved';
      percentageSpan.textContent = `Save ${percentageSaved}%`;
      priceElement.insertAdjacentElement('afterend', percentageSpan); // Insert after the actual price
      productContainer.style.display = 'inline-flex'; 
    }else{

       productContainer.style.display = 'none'; 
    }
  }
});